<div class="contacts-container">
  <!-- Header -->
  <div class="section-header">
    <div class="header-content">
      <h2>Contacts</h2>
      <p class="section-description">Manage all contacts in the system</p>
    </div>
    <button class="btn btn-primary" (click)="startCreate()" [disabled]="isCreating || isSaving">
      <i class="fas fa-plus"></i> Add Contact
    </button>
  </div>

  <!-- Messages -->
  <div class="message error-message" *ngIf="errorMessage">
    <i class="fas fa-exclamation-circle"></i> {{ errorMessage }}
  </div>
  <div class="message success-message" *ngIf="successMessage">
    <i class="fas fa-check-circle"></i> {{ successMessage }}
  </div>

  <!-- Loading State -->
  <div class="loading-container" *ngIf="isLoading">
    <i class="fas fa-spinner fa-spin"></i> Loading contacts...
  </div>

  <!-- Filters -->
  <div class="filters-row" *ngIf="!isLoading">
    <div class="search-box">
      <i class="fas fa-search"></i>
      <input type="text" [(ngModel)]="searchQuery" placeholder="Search contacts..." />
    </div>
    <div class="filter-group">
      <label>Status:</label>
      <select [(ngModel)]="statusFilter">
        <option value="all">All</option>
        <option value="Active">Active</option>
        <option value="Pending">Pending</option>
        <option value="Inactive">Inactive</option>
        <option value="Suspended">Suspended</option>
      </select>
    </div>
  </div>

  <!-- Create Form -->
  <div class="create-form card" *ngIf="isCreating">
    <h3>New Contact</h3>
    <div class="form-grid">
      <div class="form-group">
        <label>First Name *</label>
        <input type="text" [(ngModel)]="createForm.firstName" placeholder="First name" />
      </div>
      <div class="form-group">
        <label>Last Name *</label>
        <input type="text" [(ngModel)]="createForm.lastName" placeholder="Last name" />
      </div>
      <div class="form-group">
        <label>Email *</label>
        <input type="email" [(ngModel)]="createForm.email" placeholder="Email address" />
      </div>
      <div class="form-group">
        <label>Title</label>
        <input type="text" [(ngModel)]="createForm.title" placeholder="Job title" />
      </div>
      <div class="form-group">
        <label>Profile Image URL</label>
        <input type="url" [(ngModel)]="createForm.profileImageURL" placeholder="https://..." />
      </div>
      <div class="form-group">
        <label>Status</label>
        <select [(ngModel)]="createForm.status">
          <option value="Active">Active</option>
          <option value="Pending">Pending</option>
          <option value="Inactive">Inactive</option>
        <option value="Suspended">Suspended</option>
        </select>
      </div>
    </div>
    <div class="form-actions">
      <button class="btn btn-secondary" (click)="cancelCreate()" [disabled]="isSaving">Cancel</button>
      <button class="btn btn-primary" (click)="saveCreate()" [disabled]="isSaving">
        <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
        {{ isSaving ? 'Saving...' : 'Create Contact' }}
      </button>
    </div>
  </div>

  <!-- Contacts Grid -->
  <div class="contacts-grid" *ngIf="!isLoading">
    <div class="contact-card card" *ngFor="let cd of filteredContacts">
      <!-- View Mode -->
      <ng-container *ngIf="!cd.isEditing">
        <div class="contact-header">
          <div class="avatar" *ngIf="!cd.contact.ProfileImageURL">
            {{ getInitials(cd.contact.FirstName, cd.contact.LastName) }}
          </div>
          <img class="avatar-img" *ngIf="cd.contact.ProfileImageURL" [src]="cd.contact.ProfileImageURL" [alt]="cd.contact.FirstName" />
          <div class="contact-info">
            <h4>{{ cd.contact.FirstName }} {{ cd.contact.LastName }}</h4>
            <p class="title" *ngIf="cd.contact.Title">{{ cd.contact.Title }}</p>
            <p class="email">{{ cd.contact.Email }}</p>
          </div>
          <span class="status-badge" [ngClass]="getStatusClass(cd.contact.Status)">
            {{ cd.contact.Status }}
          </span>
        </div>
        <div class="contact-actions">
          <button class="btn btn-icon" title="Edit" (click)="startEdit(cd)" [disabled]="isSaving">
            <i class="fas fa-edit"></i>
          </button>
          <button class="btn btn-icon btn-danger" title="Delete" (click)="confirmDelete(cd)" [disabled]="isSaving">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </ng-container>

      <!-- Edit Mode -->
      <ng-container *ngIf="cd.isEditing">
        <div class="edit-form">
          <div class="form-row">
            <div class="form-group">
              <label>First Name</label>
              <input type="text" [(ngModel)]="cd.editForm.firstName" />
            </div>
            <div class="form-group">
              <label>Last Name</label>
              <input type="text" [(ngModel)]="cd.editForm.lastName" />
            </div>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" [(ngModel)]="cd.editForm.email" />
          </div>
          <div class="form-group">
            <label>Title</label>
            <input type="text" [(ngModel)]="cd.editForm.title" />
          </div>
          <div class="form-group">
            <label>Profile Image URL</label>
            <input type="url" [(ngModel)]="cd.editForm.profileImageURL" />
          </div>
          <div class="form-group">
            <label>Status</label>
            <select [(ngModel)]="cd.editForm.status">
              <option value="Active">Active</option>
              <option value="Pending">Pending</option>
              <option value="Inactive">Inactive</option>
        <option value="Suspended">Suspended</option>
            </select>
          </div>
          <div class="form-actions">
            <button class="btn btn-secondary" (click)="cancelEdit(cd)" [disabled]="isSaving">Cancel</button>
            <button class="btn btn-primary" (click)="saveEdit(cd)" [disabled]="isSaving">
              <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
              Save
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="filteredContacts.length === 0 && !isCreating">
      <i class="fas fa-users"></i>
      <p>No contacts found</p>
      <button class="btn btn-primary" (click)="startCreate()">Add Your First Contact</button>
    </div>
  </div>

  <!-- Confirm Dialog -->
  <div class="modal-overlay" *ngIf="confirmDialogVisible" (click)="closeConfirmDialog()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <h3>{{ confirmDialogTitle }}</h3>
      <p>{{ confirmDialogMessage }}</p>
      <div class="modal-actions">
        <button class="btn btn-secondary" (click)="closeConfirmDialog()">Cancel</button>
        <button class="btn btn-danger" (click)="confirmDialogYes()" [disabled]="isSaving">
          <i class="fas fa-spinner fa-spin" *ngIf="isSaving"></i>
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
